import React, { useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import PhoneIcon from "@mui/icons-material/Phone";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TextBox from "../components/textbox";
import { toast } from "react-toastify";
import axios from "axios";
import { getYear } from "date-fns";
import FlodeskForm from "./flodeskBlog";

const Footer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const openUrl = (url) => {
    window.open(url, "_blank");
  };

  const handleSubscribeNewsLetter = () => {
    axios
      .post(process.env.REACT_APP_BACKEND + "news-room/subscribe-newsletter", {
        email: email,
      })
      .then((resp) => {
        setEmail("");
        toast.success(resp.data.message);
      })
      .catch((err) => {
        console.log(err?.response.data.error);
        toast.error(err?.response.data.error);
      });
  };

  return (
    <div className="footer-cont">
      <div className="container">
        <div className="row">
          {/* Company Info */}
          <div className="col-md-3">
            <h2>Sevenly Travel</h2>
            <p className="mt-3 c-pointer" onClick={() => navigate("/aboutus")}>
              About us
            </p>
            <p className="mt-3 c-pointer">Contact us</p>
          </div>

          {/* Community */}
          <div className="col-md-3 mq-mt2">
            <h2>Community</h2>
            <p
              className="mt-3 c-pointer"
              onClick={() => navigate("/terms-conditions")}
            >
              Terms and Conditions
            </p>
            <p className="mt-3 c-pointer" onClick={() => navigate("/faq")}>
              FAQ
            </p>
          </div>

          {/* Join Us */}
          <div className="col-md-3 mq-mt2">
            <h2>Join Us</h2>
            <p
              className="mt-3 c-pointer"
              onClick={() => navigate("/affiliate/influencer")}
            >
              Influencer Program
            </p>
            <p
              className="mt-3 c-pointer"
              onClick={() => navigate("/affiliate/b2b")}
            >
              Partner Program
            </p>
          </div>

          {/* Newsletter */}
          <div className="col-md-3">
            <div className="w100">
              <FlodeskForm id="67d978c155ffe5ba819d8ac7" />
            </div>
            <p className="mt-2 fs-8 t-center">
              For announcements and exclusive deals
            </p>
            <div
              className="mt-2 t-center"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <PhoneIcon
                style={{ color: "var(--primary-color)", width: "18px" }}
              />
              <p className="fs-8" style={{ margin: 0 }}>
                (866) 760-5088
              </p>
            </div>
          </div>
        </div>

        <hr className="mt-4 mb-3" />

        <div className="row">
          <div className="col-md-9">
            <p>Copyright © {getYear(new Date())} Sevenly Travel</p>
          </div>
          <div className="col-md-3">
            <div
              className="d-flex align-items-center justify-content-end"
              style={{ gap: "15px" }}
            >
              <FacebookIcon
                className="c-pointer"
                onClick={() =>
                  openUrl("https://www.facebook.com/sevenlytravel")
                }
              />
              <InstagramIcon
                className="c-pointer"
                onClick={() =>
                  openUrl("https://www.instagram.com/sevenlytravel/")
                }
              />
              <YouTubeIcon
                className="c-pointer"
                onClick={() => openUrl("http://www.youtube.com/@SevenlyTravel")}
              />
              <LinkedInIcon
                className="c-pointer"
                onClick={() =>
                  openUrl("https://www.linkedin.com/company/sevenlytravel")
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
